import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image, ScrollView, ActionSheetIOS, Platform, Dimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { FontAwesome5, Entypo, FontAwesome } from '@expo/vector-icons';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import Images from '../../constants/Images';
import { projectGalleryToolTip } from '../../constants/Arrays';
import { Loader, Button, BackgroundGradient, TextInputContainer, AddressPicker, LocationPicker, Validate, Tag, PhotosDocumentsAddPreviewGrid, CachedImage, Alert, ToolTipWrapper } from '../../components';
import * as ImagePicker from 'expo-image-picker';
import { Camera } from 'expo-camera';
import Constants from 'expo-constants';
import { formatPhoneNumber, getImageFieldsForUpload, getCompanyProjectGalleryImageUrl, getCompanyLogoImageUrl, manipulateImage, showAlert, dataUrlToFile, isImageExtensionValid, stripNonNumeric } from '../../utils/Functions';
import * as rtApi from '../../components/Api';
import UserState from '../../src/contexts/UserState';
import { useFocusEffect } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Money from '../../screens/SignUp/Money';
import Insurance from '../../screens/SignUp/Insurance';
import VerifyBusiness from '../../screens/SignUp/VerifyBusiness';
import SelectBox from 'react-native-multi-selectbox';
import * as Localization from 'expo-localization';
import { businessStructureOptions, addressToolTip, companyNameToolTip } from '../../constants/Arrays';
import moment from 'moment';
import { useLinkTo } from '@react-navigation/native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

const CompanyProfileScreen = ({ navigation }) => {
  const [user, setUser] = React.useContext(UserState);
  const [scrollEnabled, setScrollEnabled] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [alertOptions, setAlertOptions] = React.useState({});
  // const [newServiceArea, setNewServiceArea] = React.useState('');
  const [newSkill, setNewSkill] = React.useState('');
  const [initialLocation, setInitialLocation] = React.useState(null);

  const [existingCompany, setExistingCompany] = React.useState({ personal: { emailAddress: '', address: '', country: '', }});
  const [logo, setLogo] = React.useState(null);
  const [logoChanged, setLogoChanged] = React.useState(false);
  const [companyName, setCompanyName] = React.useState('');
  const [bio, setBio] = React.useState('');
  const [projectGallery, setProjectGallery] = React.useState([]);
  const [emailAddress, setEmailAddress] = React.useState('');
  const [phoneNumber, setPhoneNumber] = React.useState('');
  const [addressDeleted, setAddressDeleted] = React.useState(false);
  const [address, setAddress] = React.useState('');
  const [streetId, setStreetId] = React.useState(null);
  const [zipCode, setZipCode] = React.useState(null);
  const [country, setCountry] = React.useState(null);
  const [streetNumber, setStreetNumber] = React.useState(null);
  const [addressUnit, setAddressUnit] = React.useState(null);
  const [website, setWebsite] = React.useState('');
  const [serviceAreas, setServiceAreas] = React.useState([]);
  // const [skills, setSkills] = React.useState([]);
  // money
  const [plaidModalVisible, setPlaidModalVisible] = React.useState(false);
  const [moneyMethod, setMoneyMethod] = React.useState(null);
  // const [transitNo, setTransitNo] = React.useState(null);
  // const [institutionNo, setInstitutionNo] = React.useState(null);
  // const [accountNo, setAccountNo] = React.useState(null);
  const [accountId, setAccountId] = React.useState(null);
  const [accountMask, setAccountMask] = React.useState(null);
  const [accessToken, setAccessToken] = React.useState(null);
  const [itemId, setItemId] = React.useState(null);
  const [preferredPaymentIdentity, setPreferredPaymentIdentity] = React.useState('personal');
  // business
  const [structure, setStructure] = React.useState('Sole Proprietorship');
  const [businessNumber, setBusinessNumber] = React.useState('');
  const [legalName, setLegalName] = React.useState('');
  const [legalAddress, setLegalAddress] = React.useState('');
  const [legalAddressNumber, setLegalAddressNumber] = React.useState(null);
  const [legalAddressUnit, setLegalAddressUnit] = React.useState(null);
  const [legalStreetId, setLegalStreetId] = React.useState(null);
  // verify business
  const [businessIdPreview, setBusinessIdPreview] = React.useState(false);
  const [businessId, setBusinessId] = React.useState(null);
  // insurance
  const [insurance, setInsurance] = React.useState(false);
  const [insuranceIssuer, setInsuranceIssuer] = React.useState('');
  const [insurancePolicy, setInsurancePolicy] = React.useState('');
  const [insuranceExpiry, setInsuranceExpiry] = React.useState(new Date());
  const [insuranceExpiryChanged, setInsuranceExpiryChanged] = React.useState(false);
  //layout stuff for scrolling
  const [logoContainerHeight, setLogoContainerHeight] = React.useState(0);
  const [businessSectionY, setBusinessSectionY] = React.useState(0);

  const defaultIsInvalid = {
    companyName: false,
    // bio: false,
    emailAddress: false,
    phoneNumber: false,
    address: false,
    website: false,
    newServiceArea: false,
    newSkill: false,
    businessNumber: false,
    legalName: false,
    legalAddress: false,
    insuranceIssuer: false,
    insurancePolicy: false,
    insuranceExpiry: false,
  };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);

  const linkTo = useLinkTo();

  let textInputs = {
    companyName: React.useRef(null),
    bio: React.useRef(null),
    emailAddress: React.useRef(null),
    phoneNumber: React.useRef(null),
    address: React.useRef(null),
    website: React.useRef(null),
    newServiceArea: React.useRef(null),
    newSkill: React.useRef(null),
    businessNumber: React.useRef(null),
    legalName: React.useRef(null),
    legalAddress: React.useRef(null),
    insuranceIssuer: React.useRef(null),
    insurancePolicy: React.useRef(null),
    insuranceExpiry: React.useRef(null),
  };

  let scrollRef = React.useRef(null);

  const defaultLogo = require('../../assets/img/blank_company_logo.jpg');
  const insets = useSafeAreaInsets();

  

  useFocusEffect(
    React.useCallback(() => {
      setIsInvalid(defaultIsInvalid);
      getCompanyProfile(user.company_id);
    }, [user.company_id])
  );
  React.useEffect(() => {
    if (Localization.region === 'US') {
      setBusinessNumberLabel('Employer Identification Number (EIN)');
    }
  }, []);
  React.useEffect(() => {
    console.log('address: ', address);
  }, [address]);
  const [localStructure, setLocalStructure] = React.useState({
    item: 'Sole Proprietorship',
    id: 1,
  });
  const [businessNumberLabel, setBusinessNumberLabel] = React.useState('Business Number');

  const getCompanyProfile = async (companyId) => {
    setLoading(true);
    rtApi.get(`companies/${companyId}`)
    // rtApi.get(`companies/72`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      // data.company.personal.address_display = 'Test Address Display'; // remove after real one added in api
      setExistingCompany({...data.company});
      processCompanyData(data.company);
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setLoading(false);
    });
  }
  const processCompanyData = (company) => {
    console.log('process company data');
    setCompanyName(company.name);
    setBio(company.bio || '');
    setAddress(company.address);
    setStreetId(company.street_id);
    setStreetNumber(company.address_number);
    setAddressUnit(company.address_unit);
    setZipCode(company.zip_code);
    setCountry(company.country);
    setWebsite(company.website || '');
    setEmailAddress(company.email_address);
    setServiceAreas(company.service_areas);
    setPhoneNumber(company.phone_number);
    setMoneyMethod(company.preferred_payment_method);
    // setTransitNo(company.transit_number)
    // setInstitutionNo(company.institution_number);
    // setAccountNo(company.account_number);
    setPreferredPaymentIdentity(company.preferred_payment_identity);
    setStructure(company.structure);
    setLocalStructure(businessStructureOptions.filter(o => {
      return o.item === company.structure
    })[0])
    setBusinessNumber(String(company.business_number || ''));
    setLegalName(company.legal_name || '');
    setLegalAddress(company.legal_address || '');
    setLegalAddressNumber(company.legal_address_number);
    setLegalAddressUnit(company.legal_address_unit);
    setLegalStreetId(company.legal_street_id);

    setInsurance(company.insurance === 'Yes' ? true : false);
    setInsuranceIssuer(company.insurance_insurer);
    setInsurancePolicy(String(company.insurance_policy));
    setInsuranceExpiry(company.insurance_expiry ? (Platform.OS === 'web' ? company.insurance_expiry : moment(company.insurance_expiry).toDate()) : new Date());

    setAccountId(null);
    setAccountMask(String(company.account_mask));
    setAccessToken(null);

    setBusinessId(company.business_id ? { existing: true, type: company.business_id_type, version: company.business_id } : null);

    let pg = company.project_gallery.map(p => { return { existing: true, path: getCompanyProjectGalleryImageUrl(user.company_id, p), type: 'image', id: p, } });
    setProjectGallery(pg);
    // setSkills(company.skills.map(s => { return s.skill }));
    console.log('setProjectGallery: ', pg);
    if(!company.logo){
      setLogo(null);
    }else{
      setLogo({ existing: true, uri: getCompanyLogoImageUrl(user.company_id, company.logo) });
      console.log('hasLogo: ', getCompanyLogoImageUrl(user.company_id, company.logo));
    }
    setLogoChanged(false);
    setIsInvalid(defaultIsInvalid);
  }

  const checkCompanyProfile = async () => {
    // setShowSuccessAlert(true);
    // return;
    // companyName
    if (!Validate.Name(companyName)) {
      setIsInvalid(prevState => { return { ...prevState, companyName: true } });
      textInputs.companyName.current.focus();
      scrollToPosition(0);
      return false;
    }
    setIsInvalid(prevState => { return { ...prevState, companyName: false } });

    // address
    console.log('test', streetId);
    // if (!streetId) {
    //   setIsInvalid(prevState => { return { ...prevState, address: true } });
    //   textInputs.address.current.focus();
    //   return false;
    // }
    // setIsInvalid(prevState => { return { ...prevState, address: false } });

    // website
    // if (!Validate.Url(props.website)) {
    //   setIsInvalid(prevState => { return { ...prevState, website: true } });
    //   textInputs.website.current.focus();
    //   return;
    // }
    // setIsInvalid(prevState => { return { ...prevState, website: false } });

    // service areas
    // if(props.serviceAreas.length === 0){
    //   Alert.alert('Error', 'You must add at least 1 service area');
    //   setIsInvalid(prevState => { return { ...prevState, newServiceArea: true } });
    //   textInputs.newServiceArea.current.focus();
    //   return;
    // }

    // skills
    // if (props.skills.length === 0) {
    //   Alert.alert('Error', 'You must add at least 1 skill');
    //   setIsInvalid(prevState => { return { ...prevState, newSkill: true } });
    //   textInputs.newSkill.current.focus();
    //   return;
    // }
    
    if (structure !== 'Individual') {
      // businessNumber
      if (!Validate.BusinessNumber(businessNumber)) {
        setIsInvalid(prevState => { return { ...prevState, businessNumber: true } });
        textInputs.businessNumber.focus();
        scrollToPosition(businessSectionY + logoContainerHeight - insets.top + Constants.statusBarHeight);
        return;
      }
      // legalName
      if (!Validate.Blank(legalName)) {
        setIsInvalid(prevState => { return { ...prevState, legalName: true } });
        textInputs.legalName.current.focus();
        scrollToPosition(businessSectionY + logoContainerHeight - insets.top + Constants.statusBarHeight);
        return;
      }
      // address
      if (!legalAddressNumber) {
        setAlertOptions({ visible: true, title: 'Error', message: 'Address is required', });
        scrollToPosition(businessSectionY + logoContainerHeight - insets.top + Constants.statusBarHeight);
        return;
      }
    }
    save();
  };
  const buildFormData = () => {
    let fd = new FormData();
    if (companyName && companyName !== existingCompany.name){
      fd.append('name', companyName);
    }
    if (bio && bio !== existingCompany.bio) {
      fd.append('bio', bio);
    }
    if (emailAddress && emailAddress !== existingCompany.email_address) {
      fd.append('email_address', emailAddress);
    }
    if (phoneNumber && phoneNumber !== existingCompany.phone_number) {
      fd.append('phone_number', phoneNumber);
    }
    if(!addressDeleted){
      if (streetId && streetId !== existingCompany.street_id) {
        fd.append('street_id', streetId);
      }
      if (streetNumber && streetNumber !== existingCompany.address_number) {
        fd.append('address_number', streetNumber);
      }
      if (zipCode && zipCode !== existingCompany.zip_code) {
        fd.append('zip_code', zipCode);
      }
      if (addressUnit && addressUnit !== existingCompany.address_unit) {
        fd.append('address_unit', addressUnit);
      }
    }else{
      fd.append('address_remove', 'yes');
    }
    
    if (website && website !== existingCompany.website) {
      fd.append('website', website);
    }
    if(serviceAreas.length > 0){
      // let existingServiceAreas = existingCompany.serviceAreas.map(sa => { return sa.id });
      // fd.append('service_areas', JSON.stringify(serviceAreas.filter(sa => { return !existingServiceAreas.includes(sa.id); }).map(sa => { return sa.id })));
      fd.append('service_areas', JSON.stringify(serviceAreas.map(sa => { return sa.id })));
    }
    // if (skills.length > 0) {
    //   fd.append('skills', JSON.stringify(skills));
    // }
    if (logo && logoChanged) {
      console.log('logo', logo);
      if(Platform.OS !== 'web'){
        let logoDetails = getImageFieldsForUpload(logo.uri);
        fd.append('logo', {
          uri: logo.uri,
          name: logoDetails.filename,
          type: logoDetails.type,
        });
      }else{
        fd.append('logo', logo.file)
      }
    }
    fd.append('project_gallery_count', projectGallery.filter(pg => { return !pg.existing; }).length);
    let pgNum = 1;
    projectGallery.forEach((p, i) => {
      console.log('Project Gallery', p);
      if(!p.existing){
        if(Platform.OS !== 'web'){
          let projectGalleryDetails = getImageFieldsForUpload(p.uri);
          fd.append(`project_gallery${pgNum}`, {
            uri: p.uri,
            name: projectGalleryDetails.filename,
            type: projectGalleryDetails.type,
          });
        }else{
          fd.append(`project_gallery${pgNum}`, p.file)
        }
        pgNum++;
      }
    });
    // money
    // if (moneyMethod && moneyMethod !== existingCompany.preferred_payment_method) {
    //   fd.append('preferred_payment_method', moneyMethod);
    // }
    if (moneyMethod === 'direct deposit') {
      // if (transitNo !== existingCompany.transit_number) {
      //   fd.append('transit_number', transitNo);
      // }
      // if (institutionNo !== existingCompany.institution_number) {
      //   fd.append('institution_number', institutionNo);
      // }
      // if (accountNo !== existingCompany.account_number) {
      //   fd.append('account_number', accountNo);
      // }

      if (accountId && accountId !== existingCompany.account_id) {
        fd.append('account_id', accountId);
      }
      if (String(accountMask) && String(accountMask) !== String(existingCompany.account_mask)) {
        fd.append('account_mask', accountMask);
      }
      if (accessToken && accessToken !== existingCompany.access_token) {
        fd.append('access_token', accessToken);
      }
      if (itemId && itemId !== existingCompany.item_id) {
        fd.append('item_id', itemId);
      }
      fd.append('preferred_payment_identity', null);
    }
    if (moneyMethod === 'mail' || moneyMethod === 'e-transfer') {
      if (
        (preferredPaymentIdentity && preferredPaymentIdentity !== existingCompany.preferred_payment_identity)
        ||
        (moneyMethod && moneyMethod !== existingCompany.preferred_payment_method)
      ) {
        fd.append('preferred_payment_identity', preferredPaymentIdentity);
        fd.append('preferred_payment_method', moneyMethod);
      }
    }else{
      if (moneyMethod && moneyMethod !== existingCompany.preferred_payment_method) {
        fd.append('preferred_payment_method', moneyMethod);
      }
    }
    // business structure
    if (structure && structure !== existingCompany.structure) {
      fd.append('structure', structure);
    }
    if (businessNumber && businessNumber !== String(existingCompany.business_number)) {
      fd.append('business_number', businessNumber);
    }
    if (legalName && legalName !== existingCompany.legal_name) {
      fd.append('legal_name', legalName);
    }
    if (legalAddressNumber && legalAddressNumber !== existingCompany.legal_address_number) {
      fd.append('legal_address_number', legalAddressNumber);
    }
    if (legalAddressUnit && legalAddressUnit !== existingCompany.legal_address_unit) {
      fd.append('legal_address_unit', legalAddressUnit);
    }
    if (legalStreetId && legalStreetId !== existingCompany.legal_street_id) {
      fd.append('legal_street_id', legalStreetId);
    }
    // if (insurance !== existingCompany.insurance) {
    //   fd.append('insurance', insurance)
    // }
    // if (insuranceIssuer !== existingCompany.insurance_insurer) {
    //   fd.append('insurance_insurer', insuranceIssuer)
    // }
    // if (insurancePolicy !== existingCompany.insurance_policy) {
    //   fd.append('insurance_policy', insurancePolicy)
    // }
    // if (insuranceExpiry !== existingCompany.insurance_expiry) {
    //   fd.append('insurance_expiry', insuranceExpiry)
    // }
    if (businessId && !businessId.existing) {
      console.log('logo', logo);
      if(Platform.OS !== 'web'){
        let details = getImageFieldsForUpload(businessId.uri);
        fd.append('business_id', {
          uri: businessId.uri,
          name: details.filename,
          type: details.type,
        });
      }else{
        fd.append('business_id', businessId.file);
      }
    }
    // insurance
    const insuranceValue = insurance ? 'Yes' : 'No';
    if(insuranceValue !== existingCompany.insurance){
      fd.append('insurance', insuranceValue);
    }
    if (insurance) {
      if (insuranceIssuer && insuranceIssuer !== existingCompany.insurance_insurer){
        fd.append('insurance_insurer', insuranceIssuer);
      }
      if (insurancePolicy && insurancePolicy !== String(existingCompany.insurance_policy)) {
        fd.append('insurance_policy', insurancePolicy);
      }
      const expiryValue = Platform.OS === 'web' ? insuranceExpiry : moment(insuranceExpiry).format("YYYY-MM-DD");
      if (insuranceExpiryChanged && expiryValue && expiryValue !== existingCompany.insurance_expiry) {
        fd.append('insurance_expiry', expiryValue);
      }
    }

    return fd;
  }
  const save = () => {
    setLoading(true);
    let fd = buildFormData();
    console.log('saving company profile');
    rtApi.put(`companies/${user.company_id}`, fd)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      showAlert('success', 'Successfully Saved', () => scrollToPosition(0));
      console.log('companies put', data);
      processCompanyData(data.company);
    }).catch(err => {
      console.log('companies put error', err);
    }).finally(() => {
      setLoading(false);
    });
  }

  const scrollToPosition = (pos) => {
    scrollRef.current.scrollToPosition(0, pos, true);
  }

  const onChangeCompanyName = (input) => {
    if (isInvalid.companyName && Validate.Name(input)) {
      setIsInvalid(prevState => { return { ...prevState, companyName: false } });
    }
    setCompanyName(input);
  };
  const onChangeBio = (input) => {
    if (isInvalid.bio && Validate.Name(input)) {
      setIsInvalid(prevState => { return { ...prevState, bio: false } });
    }
    setBio(input);
  };
  const onChangeEmailAddress = (input) => {
    if (isInvalid.emailAddress && Validate.Email(input)) {
      setIsInvalid(prevState => { return { ...prevState, emailAddress: false } });
    }
    setEmailAddress(input);
  };
  const onChangePhoneNumber = (input) => {
    input = formatPhoneNumber(input);
    if (isInvalid.phoneNumber && Validate.PhoneNumber(input)) {
      setIsInvalid(prevState => { return { ...prevState, phoneNumber: false } });
    }
    setPhoneNumber(input);
  };
  const setIsInvalidAddress = () => {
    setIsInvalid(prevState => { return { ...prevState, address: false } });
  };
  const setIsInvalidServiceArea = () => {
    setIsInvalid(prevState => { return { ...prevState, newServiceArea: false } });
  }
  const onChangeWebsite = (input) => {
    if (isInvalid.website && Validate.Url(input)) {
      setIsInvalid(prevState => { return { ...prevState, website: false } });
    }
    setWebsite(input);
  };
  const onChangeBusinessNumber = (input) => {
    input = stripNonNumeric(input);
    if (isInvalid.businessNumber && Validate.BusinessNumber(input)) {
      setIsInvalid(prevState => { return { ...prevState, businessNumber: false } });
    }
    setBusinessNumber(input);
  };
  const onChangeLegalName = (input) => {
    if (isInvalid.legalName && Validate.Blank(input)) {
      setIsInvalid(prevState => { return { ...prevState, legalName: false } });
    }
    setLegalName(input);
    // setCompanyName(input);
  };
  const isInvalidAddress = () => {
    setIsInvalid(prevState => { return { ...prevState, legalAddress: false } });
  }

  // structure
  const selectStructure = (s) => {
    setLocalStructure(s);
    setStructure(s.item);
    if (s.item === 'Sole Proprietorship' || s.item === 'Individual') {
      setPreferredPaymentIdentity('personal');
    } else {
      setPreferredPaymentIdentity('company');
    }
    if(s.item === 'Individual'){
      setBusinessNumber(null);
      setLegalName(null);
      setLegalAddress(null);
      setLegalAddressNumber(null);
      setLegalAddressUnit(null);
      setLegalStreetId(null);
    }
  }

  //logo
  const chooseLogo = async () => {
    // if (Platform.OS !== 'web') {
      const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
      if (status !== 'granted') {
        Alert('warning', 'Sorry, we need camera roll permissions to make this work!');
      } else {
        let result = await ImagePicker.launchImageLibraryAsync({
          mediaTypes: ImagePicker.MediaTypeOptions.Images,
          allowsEditing: true,
          aspect: [Images.company.logo.width, Images.company.logo.height],
          quality: 1,
        });
        console.log(result);
        if (!result.canceled) {
          result.assets[0].existing = false;
          let manipResult = await manipulateImage(result.assets[0], Images.company.logo.width, Images.company.logo.height);
          if (Platform.OS === 'web') {
            manipResult.file = await dataUrlToFile(manipResult.uri);
          }

          const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? manipResult.file.name : manipResult.uri);
          if (!isValidExtension.result) {
            setAlertOptions({ visible: true, title: 'Error', message: `Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`, });
            return;
          }

          if (!manipResult.cancelled) {
            setLogo(manipResult);
            setLogoChanged(true);
          }
        }
      }
    // }
  }

  const removeServiceArea = (s) => {
    console.log('removeServiceArea ', s, serviceAreas);
    setServiceAreas(prevState => {
      return prevState.filter(p => {
        return p.id !== s;
      });
    });
  };
  // const verifySkill = (s) => {
  //   return !skills.includes(s);
  // }
  // const addSkill = () => {
  //   let newSkills = newSkill.split(',').filter((s) => {
  //     return verifySkill(s);
  //   }).map((s) => {
  //     return String(s).trim();
  //   });
  //   setSkills([...skills, ...newSkills]);
  //   setNewSkill('');
  // }
  // const removeSkill = (s) => {
  //   setSkills(prevState => {
  //     return prevState.filter(p => {
  //       return p !== s;
  //     });
  //   });
  // };

  // verify business
  const removeBusinessId = (uri) => {
    console.log('removeBusinessId');
    setBusinessId(null);
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo('/projects');
    }
  }

  const afterSelectLocation = () => {
    setTimeout(() => { setScrollEnabled(true); }, 250);
  }

  const webLogoStyle = () => {
    if (Platform.OS === 'web') {
      const screenWidth = Dimensions.get('window').width;
      return {
        width: '100%',
        maxWidth: 768,
        height: screenWidth >= 768 ? 768 * 0.5625 : screenWidth * 0.5625,
      }
    }
    return {
      aspectRatio: 960 / 540,
    }
  }

  const onMessage = (event) => {
    console.log('onMessage companyProfile: ', event);
    switch(event.data.action){
      case 'complete':
        getCompanyProfile(user.company_id);
        break;
    }
  }

  return (
    <View style={{ flex: 1, position: 'relative' }}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' ref={scrollRef} enableAutomaticScroll={scrollEnabled} style={styles.container} contentContainerStyle={styles.innerContainer}>
        <View style={styles.logoContainer} onLayout={e => setLogoContainerHeight(e.nativeEvent.layout.height)}>
          {!logo &&
            <Image source={defaultLogo} style={[CS.responsiveImage, styles.logo, webLogoStyle()]} />
            // <Image source={{ uri: 'https://dev.renovationtrust.com/api/v1/companies/64/project_gallery/6' }} style={[CS.responsiveImage, styles.logo]} />
          }
          {(logo && logo.existing) &&
            <CachedImage source={{ uri: logo.uri }} style={[CS.responsiveImage, styles.logo, webLogoStyle()]} />
          }
          {(logo && !logo.existing) &&
            <Image source={{ uri: logo.uri }} style={[CS.responsiveImage, styles.logo, webLogoStyle()]} />
          }
          <LinearGradient colors={[Colors.darkGrey, 'transparent', Colors.darkGrey]} style={styles.gradient} />
          <TouchableOpacity onPress={chooseLogo} style={styles.editButton}>
            {/* <Entypo name="edit" size={24} color="white" /> */}
            <FontAwesome name="image" size={32} color="white" />
          </TouchableOpacity>
        </View>
        <View style={styles.buttonsOverlay}>
          <TouchableOpacity onPress={goBack}>
            <FontAwesome5 name="arrow-left" size={24} color="white" />
          </TouchableOpacity>
        </View>
        <View style={[styles.marginContainer, { marginTop: 10 }]}>
          <View style={[CS.rowContainer, styles.inputLabel]}>
            <Text style={[CS.smallText, CS.lightBlueText]}>Operating Name</Text>
            <ToolTipWrapper
              text={companyNameToolTip}
            />
          </View>
          <TextInputContainer
            placeholder='Operating Name'
            onChangeText={(t) => onChangeCompanyName(t)}
            inputRef={textInputs.companyName}
            isInvalid={isInvalid.companyName}
            spellCheck={false}
            onSubmitEditing={() => textInputs.bio.current.focus()}
            returnKeyType='next'
            textContentType='organizationName'
            autoCapitalize='words'
            value={companyName}
          />
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Bio</Text>
          <TextInputContainer
            placeholder='Tell us about your company and what you do'
            onChangeText={(t) => onChangeBio(t)}
            inputRef={textInputs.bio}
            isInvalid={isInvalid.bio}
            returnKeyLabel='done'
            value={bio}
            inputStyle={styles.bio}
            multiline={true}
            numberOfLines={6}
            autoCorrect={false}
            spellCheck={true}
          />

          {/* project gallery */}
          <View style={[CS.rowContainer, styles.title]}>
            <Text style={[CS.smallTitle, CS.lightText]}>Project Gallery</Text>
            <ToolTipWrapper
              text={projectGalleryToolTip}
            />
          </View>
          <PhotosDocumentsAddPreviewGrid
            items={projectGallery}
            setItems={setProjectGallery}
            uploadDeleteUrl={`companies/${user.company_id}/project_gallery/:id`}
            showAdd={true}
            delete={true}
            captions={false}
          />

          <Text style={[CS.smallTitle, CS.lightText, styles.title]}>Contact</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Company Email</Text>
          <TextInputContainer
            placeholder='Email Address'
            textContentType='emailAddress'
            onChangeText={(t) => onChangeEmailAddress(t)}
            inputRef={textInputs.emailAddress}
            keyboardType='email-address'
            isInvalid={isInvalid.emailAddress}
            autoCapitalize='none'
            autoCompleteType='email'
            autoCorrect={false}
            returnKeyType='next'
            onSubmitEditing={() => textInputs.phoneNumber.current.focus()}
            value={emailAddress}
          />
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Phone Number</Text>
          <TextInputContainer
            placeholder='Main Phone Number'
            onChangeText={(t) => onChangePhoneNumber(t)}
            inputRef={textInputs.phoneNumber}
            isInvalid={isInvalid.phoneNumber}
            spellCheck={false}
            textContentType='telephoneNumber'
            autoCompleteType='tel'
            keyboardType='phone-pad'
            onSubmitEditing={() => textInputs.address.current.focus()}
            returnKeyType='done'
            value={phoneNumber}
          />

          <View style={[CS.rowContainer, styles.inputLabel]}>
            <Text style={[CS.smallText, CS.lightBlueText]}>Address</Text>
            <ToolTipWrapper
              text={addressToolTip}
            />
          </View>
          <AddressPicker
            placeholder='100-45 Main Street. Toronto, ON'
            value={address}
            setAddressDeleted={setAddressDeleted}
            setAddress={setAddress}
            setStreetId={setStreetId}
            setStreetNumber={setStreetNumber}
            setAddressUnit={setAddressUnit}
            setZipCode={setZipCode}
            setCountry={setCountry}
            offsetTop={Constants.statusBarHeight}
            // outerInputContainerStyle={styles.marginContainer}
            isSet={streetId ? true : false}
            inputRef={textInputs.address}
            setIsInvalid={setIsInvalidAddress}
            isInvalid={isInvalid.address}
            scrollRef={scrollRef}
            afterSelectLocation={afterSelectLocation}
            setScrollEnabled={setScrollEnabled}
          />

          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Website</Text>
          <TextInputContainer
            placeholder='Website'
            onChangeText={(t) => onChangeWebsite(t)}
            inputRef={textInputs.website}
            isInvalid={isInvalid.website}
            spellCheck={false}
            autoCapitalize='none'
            // onSubmitEditing={() => textInputs.newServiceArea.current.focus()}
            // returnKeyType='next'
            textContentType='URL'
            returnKeyType='next'
            keyboardType='url'
            value={website}
          />

          <Text style={[CS.smallTitle, CS.lightText, styles.title]}>Service Areas</Text>
          <LocationPicker
            placeholder='Type a city'
            // value='Mississauga, ON'
            locations={serviceAreas}
            setLocations={setServiceAreas}
            streetId={streetId}
            offsetTop={Constants.statusBarHeight}
            // outerInputContainerStyle={styles.marginContainer}
            inputRef={textInputs.newServiceArea}
            setIsInvalid={setIsInvalidServiceArea}
            afterSelectLocation={afterSelectLocation}
            setScrollEnabled={setScrollEnabled}
          />
          <View style={styles.tags}>
            {serviceAreas.map((s) =>
              <Tag text={s.city + ', ' + s.state} key={s.id} remove={removeServiceArea} removeId={s.id} />
            )}
          </View>
        {/* </View> */}
      {/* legal business stuff */}
        <View onLayout={e => setBusinessSectionY(e.nativeEvent.layout.y)} style={{ zIndex: 1 }}>
          <Text style={[CS.smallTitle, CS.lightText, styles.title]}>Business</Text>
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Business Structure</Text>
          <SelectBox
            label=""
            options={businessStructureOptions}
            value={localStructure}
            onChange={selectStructure}
            hideInputFilter={true}
            arrowIconColor={Colors.lightGrey}
            labelStyle={{ display: 'none', }}
            optionsLabelStyle={{ color: Colors.lightText, padding: 8, backgroundColor: Colors.textInputBackground }}
            selectedItemStyle={{ color: Colors.lightText }}
            containerStyle={{ borderWidth: 1, borderRadius: 10, backgroundColor: Colors.textInputBackground, padding: 8, height: 44, borderColor: Colors.lightBlue, alignItems: 'center' }}
            optionContainerStyle={{ borderWidth: 1, borderColor: Colors.lightBlue, padding: 0, paddingVertical: 0, paddingRight: 0, backgroundColor: Colors.textInputBackground, borderRadius: 0, width: '96%', marginLeft: '2%', flexDirection: 'column', alignItems: 'stretch' }}
            listEmptyLabelStyle={{ color: Colors.lightText, }}
          />
          {structure !== 'Individual'
          ?
          <>
            <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel, { marginTop: 20 }]}>{businessNumberLabel}</Text>
            <TextInputContainer
              // iconName='briefcase'
              // placeholder='Business Number(CA) / Tax ID(US)'
              textContentType='none'
              onChangeText={(t) => onChangeBusinessNumber(t)}
              inputRef={textInputs.businessNumber}
              keyboardType='numeric'
              // autoFocus={true} 
              isInvalid={isInvalid.businessNumber}
              value={businessNumber}
              autoCapitalize='none'
              autoCompleteType='off'
              autoCorrect={false}
              returnKeyType='done'
              enablesReturnKeyAutomatically={true}
              onSubmitEditing={() => textInputs.legalName.current.focus()}
              maxLength={9}
            />
            <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Legal Business Name</Text>
            <TextInputContainer
              // iconName='building-o'
              // placeholder='Business Name'
              textContentType='organizationName'
              onChangeText={(t) => onChangeLegalName(t)}
              inputRef={textInputs.legalName}
              keyboardType='default'
              // autoFocus={true} 
              isInvalid={isInvalid.legalName}
              value={legalName}
              autoCapitalize='words'
              autoCompleteType='off'
              autoCorrect={false}
              returnKeyType='next'
              enablesReturnKeyAutomatically={true}
              onSubmitEditing={() => textInputs.legalAddress.current.focus()}
            />
            <View style={[CS.rowContainer, styles.inputLabel]}>
              <Text style={[CS.smallText, CS.lightBlueText]}>Business Address</Text>
              <ToolTipWrapper
                text={addressToolTip}
              />
            </View>
            <AddressPicker
              // iconName='home'
              // placeholder='Legal Business Address'
              innerPlaceholder='10-1000 Main St. Toronto, ON'
              value={legalAddress}
              offsetTop={Constants.statusBarHeight}
              setAddress={setLegalAddress}
              setStreetId={setLegalStreetId}
              // setZipCode={props.setZipCode}
              setStreetNumber={setLegalAddressNumber}
              setAddressUnit={setLegalAddressUnit}
              // setCountry={props.setCountry}
              // setLongitude={props.setLongitude}
              // setLatitude={props.setLatitude}
              isSet={legalStreetId ? true : false}
              inputRef={textInputs.legalAddress}
              setIsInvalid={isInvalidAddress}
              isInvalid={isInvalid.legalAddress}
            />
          </>
        
          : <View style={{ marginVertical: 10 }}></View>
          }
        </View>
        {/* verify business */}
        <Text style={[CS.smallTitle, CS.lightText, styles.title]}>Verify Business</Text>
        <VerifyBusiness
          businessIdPreview={businessIdPreview}
          setBusinessIdPreview={setBusinessIdPreview}
          removeBusinessId={removeBusinessId}
          setBusinessId={setBusinessId}
          businessId={businessId}
          structure={structure}
        />
        {/* preferred payment method */}
          <Text style={[CS.smallTitle, CS.lightText, styles.title, { marginTop: 20 }]}>Preferred Payment Method</Text>
          <Money
            setMoneyMethod={setMoneyMethod}
            // setTransitNo={setTransitNo}
            // setInstitutionNo={setInstitutionNo}
            // setAccountNo={setAccountNo}
            setAccountId={setAccountId}
            setAccountMask={setAccountMask}
            setAccessToken={setAccessToken}
            setItemId={setItemId}
            setPreferredPaymentIdentity={setPreferredPaymentIdentity}
            moneyMethod={moneyMethod}
            // transitNo={transitNo}
            // institutionNo={institutionNo}
            // accountNo={accountNo}
            accountId={accountId}
            accountMask={accountMask}
            accessToken={accessToken}
            itemId={itemId}
            preferredPaymentIdentity={preferredPaymentIdentity}
            fullName={existingCompany.full_name}
            address={existingCompany.personal.address}
            // address={existingCompany.personal.address_display}
            zipCode={null}
            country={existingCompany.personal.country}
            emailAddress={existingCompany.personal.email_address}
            // companyName={existingCompany.name}
            // contractorAddress={existingCompany.address}
            // contractorCountry={existingCompany.country}
            // contractorZipCode={existingCompany.zip_code}
            // contractorEmailAddress={existingCompany.email_address}
            companyName={companyName}
            contractorAddress={address}
            contractorCountry={country}
            contractorZipCode={zipCode}
            contractorEmailAddress={emailAddress}
            legalName={legalName}
            legalAddress={legalAddress}
            type='Edit'
            structure={structure}
            onMessage={onMessage}
          />

          {/* <Insurance
            insurance={insurance}
            setInsurance={setInsurance}
            insuranceIssuer={insuranceIssuer}
            setInsuranceIssuer={setInsuranceIssuer}
            insurancePolicy={insurancePolicy}
            setInsurancePolicy={setInsurancePolicy}
            insuranceExpiry={insuranceExpiry}
            setInsuranceExpiry={setInsuranceExpiry}
            setInsuranceExpiryChanged={setInsuranceExpiryChanged}
            textInputs={textInputs}
            isInvalid={isInvalid}
            setIsInvalid={setIsInvalid}
          /> */}
          
        </View>
        <View style={[styles.marginContainer, { marginBottom: 30, marginTop: 10 }]}>
          <Button text='Save' onPress={() => checkCompanyProfile} />
        </View>
        {/* </View> */}
      </KeyboardAwareScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  safe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  container: {
    width: '100%',
    flex: 1,
    marginBottom: 10,
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf: 'center',
  },
  scrollView: {
    backgroundColor: Colors.blue,
    flex: 1,
  },
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    // position: 'relative',
    // backgroundColor: 'pink',
  },
  marginContainer: {
    marginHorizontal: 10,
  },
  logo: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },
  gradient: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: '100%',
  },
  buttonsOverlay: {
    position: 'absolute',
    top: 40,
    left: 0,
    width: '100%',
    padding: 15,
    flexDirection: 'row',
    alignItems: 'center',
  },
  editButton: {
    // marginLeft: 'auto',
    // marginRight: 15,
    position: 'absolute',
    bottom: 20,
    right: 20,
  },
  section: {
    marginBottom: 20,
  },
  gallery: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // justifyContent: 'space-between',
    // flex: 1,
  },
  thumbContainer: {
    borderRadius: 5,
    flex: 1,
    flexBasis: '23.5%',
    flexGrow: 0,
    marginRight: '2%',
    marginBottom: '2%',
  },
  thumbContainerNoRightMargin: {
    borderRadius: 5,
    flex: 1,
    flexBasis: '23.5%',
    flexGrow: 0,
    marginRight: 0,
    marginBottom: '2%',
  },
  thumb: {
    aspectRatio: 150 / 150,
    borderRadius: 5,
  },
  title: {
    marginVertical: 10,
  },
  inputLabel: {
    marginBottom: 7,
  },
  bio: {
    height: 140,
    textAlignVertical: 'top',
  },
  photos: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  newPhotoContainer: {
    backgroundColor: Colors.yellow,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center'
  },
  photoPlus: {
    position: 'absolute',
  },
  // photoButtons: {
  //   // marginLeft: 'auto',
  //   flexDirection: 'row',
  // },
  // photoButton: {
  //   flexDirection: 'row',
  //   backgroundColor: Colors.yellow,
  //   padding: 5,
  //   borderRadius: 10,
  //   alignItems: 'center',
  // },
  // photoButtonText: {
  //   fontSize: 18,
  //   marginLeft: 5,
  // },
  tags: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: -5,
    marginBottom: 10,
  },
  // verify business
  acceptableIdsList: {
    marginTop: 10,
    marginBottom: 20,
  },
  ids: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // marginBottom:20,
  },
  addNewId: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: Colors.lightBlue,
    width: '100%',
    padding: 10,
    marginBottom: '4%',
  },
  addNewText: {
    color: Colors.lightBlue,
    fontSize: 24,
  },
  businessIdPreviewContainer: {
    width: '100%',
    height: 240,
    marginBottom: 10,
  },
  businessIdPreview: {
    flex: 1,
    borderRadius: 10,
    justifyContent: 'center',
    marginBottom: 10,
    width: '100%',
    // aspectRatio: 1,
  },
  takeBusinessIdText: {
    padding: 20,
    width: '100%',
    backgroundColor: Colors.transparentGrey,
    textAlign: 'center',
    fontSize: 24,
  },
});

export default React.memo(CompanyProfileScreen);